import React from 'react';
import { Container, Header } from 'semantic-ui-react';
import { Parallax } from 'react-parallax';

export const PageTitle = ({ title, name, children, bgImg }) => {
  const className = `page-title title-${name}`;
  if (!bgImg) {
    bgImg = '/img/header-about.png';
  }

  return (
    <Container fluid className={className}>
      <Parallax strength={300} bgImage={bgImg}>
        <Header as='h1' textAlign='center'>{title}</Header>
        <div className='page-description'>{children}</div>
      </Parallax>
    </Container>
  );
};